import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as suggestionsActions from 'action/suggestions'
import ContentHeader from 'component/utils/ContentHeader'
import SuggestionHeader from 'component/suggestion/Header'
import Form from 'component/suggestion/EditForm'

class SuggestionEditContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    update: PropTypes.func.isRequired,
    suggestion: PropTypes.object.isRequired,
    error: PropTypes.object,
    resetSuggestions: PropTypes.func.isRequired,
    updateShow: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleOpenEdit = this.handleOpenEdit.bind(this)
  }

  componentWillUnmount() {
    const { resetSuggestions } = this.props

    resetSuggestions()
  }

  handleOpenEdit(values) {
    const {
      updateShow,
      auth: { user },
    } = this.props

    updateShow(user.dsToken, values)
  }

  handleSubmit(values) {
    const {
      update,
      auth: { user },
    } = this.props

    update(user.dsToken, values)
  }

  renderFieldsErrors = (fields) => (
    <li className='margin-left' key={fields.naField}>
      {fields.naField ? `${fields.naField}:` : ''} {fields.dsDetail}
    </li>
  )

  render() {
    const {
      translate,
      suggestion,
      error,
      auth: { user },
    } = this.props

    return (
      <section>
        <ContentHeader>{translate('suggestions.title')}</ContentHeader>

        <SuggestionHeader
          translate={translate}
          pageName={translate('suggestions.title')}
        />

        <section className='container-fluid'>
          <div className='container-fluid'>
            {
              // shows notification after an update
              error && error.fields ? (
                <div className='margin-top margin-botton notification notification-warning'>
                  {error.fields.map(this.renderFieldsErrors)}
                </div>
              ) : error ? (
                <div className='margin-top margin-botton notification notification-warning'>
                  {error.message.dsMessage}
                </div>
              ) : (
                ''
              )
            }
          </div>

          <Form
            translate={translate}
            onSubmit={this.handleSubmit}
            onOpen={this.handleOpenEdit}
            suggestion={suggestion}
            error={error}
            user={user}
          />
        </section>
      </section>
    )
  }
}

/*
 * Maps redux state to component props
 */
/* istanbul ignore next */
const mapStateToProps = ({ suggestionReducer }) => ({
  suggestion: suggestionReducer.get.record,
  error: suggestionReducer.edit.error,
})

/*
 * Maps actions and dispatch them to component props
 */
/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(suggestionsActions, dispatch)

/*
 * Connects component to I18next
 */
const SuggestionEditTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(SuggestionEditContainer)

/*
 * Exports component connected to redux as default
 */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuggestionEditTranslated)

/*
 * Exports as component
 */
export { SuggestionEditContainer as SuggestionEdit }
